// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__JRjwS","left":"InfoRow_left__vKQHN"};